import { render, staticRenderFns } from "./cargo-sales-agents.vue?vue&type=template&id=66479e0c&scoped=true&"
import script from "./cargo-sales-agents.vue?vue&type=script&lang=js&"
export * from "./cargo-sales-agents.vue?vue&type=script&lang=js&"
import style0 from "./cargo-sales-agents.vue?vue&type=style&index=0&id=66479e0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66479e0c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SelectCustom: require('/opt/cargo.front/src/components/select/custom.vue').default,BaseLayoutPageHeader: require('/opt/cargo.front/src/components/base/layout/page-header.vue').default,RzContainer: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/components/container/index.js').default})
